import { DynamicField } from "@/types/field.types";
import { Box, Typography, Modal, Paper, Button } from "@mui/material"

interface FieldSelectorModalProps {
    open: boolean;
    onClose: () => void;
    selectedField: DynamicField | null;
}

export const FieldSelectorModal = ({open, onClose, selectedField}: FieldSelectorModalProps) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="field-selector-modal-title"
            aria-describedby="field-selector-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography 
                    id="field-selector-modal-title" 
                    variant="h6" 
                    component="h2"
                    sx={{ mb: 2 }}
                >
                    Clinical Field Description
                </Typography>
                
                {selectedField ? (
                    <Box sx={{ mt: 2 }}>
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: 'text.primary',
                                mb: 2
                            }}
                        >
                            Framework: {selectedField.description}
                        </Typography>
                        {selectedField.prompt_instructions && (
                            <Typography 
                                variant="caption" 
                                sx={{ 
                                    color: 'text.primary',
                                    display: 'block',
                                    mt: 0.5,
                                    fontSize: '0.8rem'
                                }}
                            >
                                Instructions: {selectedField.prompt_instructions.length > 100 
                                    ? `${selectedField.prompt_instructions}` 
                                    : selectedField.prompt_instructions}
                            </Typography>
                        )}
                    </Box>
                ) : (
                    <Typography 
                        id="field-selector-modal-description" 
                        variant="body2" 
                        color="text.secondary"
                    >
                        Select the fields you want to include in this case.
                    </Typography>
                )}
                
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button 
                        onClick={onClose}
                        sx={{ 
                                color: '#FFFFFF',
                                textTransform: 'none',
                                backgroundColor: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.main',
                                }
                        }}
                    >
                        Cancel
                    </Button>
                </Box>
            </Box>
        </Modal>
    )
}
